import script from "./AdminPublication.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPublication.vue?vue&type=script&setup=true&lang=js"

import "./AdminPublication.vue?vue&type=style&index=0&id=58fbb3e4&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58fbb3e4"]])

export default __exports__